export interface Article {
  id: string;
  title: string;
  excerpt: string;
  content: string;
  categorySlug: string;
  categoryName: string;
  imageUrl: string;
  authorName: string;
  authorHandle: string;
  publishedAt: string;
  viewCount: number;
  commentCount: number;
  tags: string[];
  isHot: boolean;
  isFeatured: boolean;
}

export const categories = [
  { slug: '91-chigua', name: '91吃瓜', description: '热门娱乐圈爆料与明星八卦汇总', icon: 'ri-fire-line' },
  { slug: '17-chigua', name: '17吃瓜', description: '网红圈动态与塌房事件追踪', icon: 'ri-flashlight-line' },
  { slug: 'wanghong-talou', name: '网红塌房', description: '网红翻车现场实录与深度分析', icon: 'ri-alert-line' },
  { slug: 'meiri-dasai', name: '每日大赛', description: '每日最热吃瓜话题精选合集', icon: 'ri-trophy-line' },
  { slug: 'zongyi-bagua', name: '综艺八卦', description: '综艺节目幕后花絮与嘉宾爆料', icon: 'ri-tv-line' },
  { slug: 'yule-neimu', name: '娱乐内幕', description: '娱乐圈不为人知的幕后故事', icon: 'ri-eye-line' },
];

export const articles: Article[] = [
  {
    id: 'article-1',
    title: '顶流男星深夜密会神秘女子！酒店共度8小时，经纪人回应引发更大争议',
    excerpt: '某当红流量男星被拍到深夜与一位神秘女子在某五星级酒店共度8小时。次日经纪人的回应不但没有平息争议，反而引发了新一轮网友热议。',
    content: `<p>近日，有网友在某五星级酒店附近拍到一组照片，照片中可以看到一位当红流量男星与一位神秘女子先后进入酒店，直到次日早晨才分别离开。</p>
<p>据拍摄者透露，当天晚上约11点左右，该男星乘坐保姆车抵达酒店地下车库，随后一位身穿黑色连衣裙的长发女子也从同一车辆下车，两人一前一后进入酒店电梯。</p>
<p>直到第二天早上7点多，该女子才从酒店正门独自离开，而男星则在半小时后由工作人员陪同离开。整个过程持续约8小时。</p>
<p>消息一出，立即引发网友热议。有网友表示："这是实锤了吧，证据确凿。"也有粉丝力挺："可能就是普通朋友聚会，不要过度解读。"</p>
<p>面对舆论压力，该男星经纪公司发布声明称："艺人昨晚是在酒店进行新剧剧本研讨，在场还有多位工作人员。希望大家不要传播不实信息。"然而这一说法并未获得网友认可，反而有更多质疑声音出现。</p>
<p>值得一提的是，该男星此前一直以"单身"人设示人，此次事件无疑对其公众形象造成了巨大冲击。截至目前，相关话题阅读量已突破3亿。</p>`,
    categorySlug: '91-chigua',
    categoryName: '91吃瓜',
    imageUrl: 'https://readdy.ai/api/search-image?query=Celebrity%20scandal%20night%20scene%2C%20luxury%20hotel%20entrance%20at%20night%20with%20dramatic%20lighting%2C%20paparazzi%20style%20photography%2C%20mysterious%20atmosphere%2C%20person%20walking%20into%20building%20silhouette%2C%20urban%20night%20scene%2C%20warm%20golden%20street%20lights%2C%20cinematic%20mood%2C%20blurred%20background%2C%20editorial%20style%2C%20high%20contrast%20dramatic%20composition&width=800&height=533&seq=article-hero-01&orientation=landscape',
    authorName: '吃瓜一线',
    authorHandle: '@chigua_yixian',
    publishedAt: '2026-07-07T10:30:00Z',
    viewCount: 128500,
    commentCount: 3421,
    tags: ['娱乐圈', '顶流男星', '恋情曝光', '酒店密会'],
    isHot: true,
    isFeatured: true,
  },
  {
    id: 'article-2',
    title: '千万粉丝网红直播带货翻车！被质疑虚假宣传，品牌方紧急发声明撇清关系',
    excerpt: '拥有超千万粉丝的知名带货主播在最近一场直播中被指虚假宣传某护肤品功效，品牌方连夜发布声明称"主播言论不代表品牌立场"，引发直播带货信任危机。',
    content: `<p>拥有超过1200万粉丝的知名带货主播"甜甜酱"在上周五的直播中推广某品牌护肤品时，声称该产品"使用一周就能淡化色斑、消除皱纹"，这一说法引发了消费者和业内人士的强烈质疑。</p>
<p>直播中，"甜甜酱"手持该护肤品，情绪激动地向观众表示："我跟你们说，这个产品我真的自己用了，才一周，脸上的斑就淡了！这绝对不是广告，是我亲身体验！"</p>
<p>然而，多位皮肤科医生在社交媒体上指出，市面上没有任何护肤品能在短短一周内实现如此显著的效果，该主播的言论涉嫌虚假宣传。</p>
<p>更有网友扒出该主播去年在其他直播中推广同类型产品时，也使用了几乎一模一样的说辞，质疑其"亲身体验"的真实性。</p>
<p>事件发酵后，品牌方连夜发布声明称："主播在直播中的部分言论为个人观点，不代表品牌立场。本品牌产品功效以官方说明为准。"这则声明被网友解读为品牌方急于撇清关系。</p>
<p>目前，"甜甜酱"尚未对此事做出正式回应，但其最新一条社交动态下已有超过5万条评论，其中大量是要求其出面解释和道歉的声音。</p>`,
    categorySlug: 'wanghong-talou',
    categoryName: '网红塌房',
    imageUrl: 'https://readdy.ai/api/search-image?query=Live%20streaming%20ecommerce%20studio%20with%20ring%20light%20and%20beauty%20products%20on%20display%2C%20dramatic%20lighting%2C%20professional%20streaming%20setup%2C%20cosmetics%20and%20skincare%20items%20arranged%20on%20table%2C%20warm%20studio%20lighting%2C%20modern%20interior%2C%20editorial%20product%20photography%2C%20soft%20shadows&width=800&height=533&seq=article-hero-02&orientation=landscape',
    authorName: '行业观察员',
    authorHandle: '@hangye_guancha',
    publishedAt: '2026-07-06T16:45:00Z',
    viewCount: 95200,
    commentCount: 2876,
    tags: ['直播带货', '虚假宣传', '网红翻车', '消费者权益'],
    isHot: true,
    isFeatured: true,
  },
  {
    id: 'article-3',
    title: '某知名综艺节目录制现场爆发冲突！两位嘉宾因一句话当场翻脸，导演组紧急叫停',
    excerpt: '热门综艺《星光对对碰》最新一期录制现场发生意外，两位常驻嘉宾因一句玩笑话当场爆发激烈争吵，导致节目录制被迫中断三小时。',
    content: `<p>据现场工作人员透露，热门综艺《星光对对碰》最新一期录制过程中发生了一起令人意想不到的冲突事件。</p>
<p>事情的起因是嘉宾A在游戏环节中开了一句关于嘉宾B家庭背景的玩笑，虽然现场观众起初以为这只是节目效果，但嘉宾B的脸色瞬间变得非常难看。</p>
<p>"我当时就在现场，气氛真的很尴尬，"一位现场观众回忆道，"B直接站起来说'你再说一遍'，然后两个人就吵起来了。导演组赶紧叫停，把两位嘉宾分别拉到不同的休息室去沟通。"</p>
<p>据知情人透露，两位嘉宾之间早有矛盾，这次的玩笑话只是导火索。节目组花了三个小时进行调解，最终两人才勉强同意继续完成录制，但全程几乎没有互动。</p>
<p>这期节目原定于本周五播出，目前节目组正在紧急剪辑，试图将冲突片段处理得更加"综艺化"，但已经有现场观众在网上曝光了部分细节。</p>
<p>对于这一事件，节目组官方暂未做出回应。但有不少网友表示："这才是真正的综艺，比剧本好看多了！"</p>`,
    categorySlug: 'zongyi-bagua',
    categoryName: '综艺八卦',
    imageUrl: 'https://readdy.ai/api/search-image?query=TV%20variety%20show%20recording%20studio%20set%20with%20colorful%20stage%20lighting%2C%20empty%20stage%20with%20dramatic%20spotlights%2C%20professional%20broadcast%20equipment%2C%20behind%20the%20scenes%20atmosphere%2C%20television%20production%20environment%2C%20warm%20stage%20lights%2C%20entertainment%20industry%20setting&width=800&height=533&seq=article-hero-03&orientation=landscape',
    authorName: '综艺侦探',
    authorHandle: '@zongyi_zhentan',
    publishedAt: '2026-07-06T09:15:00Z',
    viewCount: 86200,
    commentCount: 2154,
    tags: ['综艺节目', '嘉宾冲突', '录制事故', '星光对对碰'],
    isHot: true,
    isFeatured: true,
  },
  {
    id: 'article-4',
    title: '知名导演被曝剧组霸凌！多位演员发声控诉，行业协会表示将介入调查',
    excerpt: '曾执导多部热播剧的知名导演张某某被多名演员联合指控在片场存在言语侮辱、人身攻击等霸凌行为，中国电影家协会已表示将对此展开调查。',
    content: `<p>近日，曾在张某某导演作品中出演配角的演员李明（化名）在社交媒体上发布长文，详细描述了在该导演剧组遭受的不公正待遇。</p>
<p>"他在片场经常对演员大吼大叫，用极其侮辱性的语言进行人身攻击，"李明在文中写道，"有一次因为我的一个走位失误，他当着全剧组的面骂了我整整十分钟，用词之难听让我至今想起来都感到窒息。"</p>
<p>这则发文迅速引发连锁反应，随后又有两位曾与张某某合作过的演员发声，描述了自己在剧组的类似经历。其中一位女演员透露，张某某曾因为服装问题对她进行了长达半小时的当众羞辱。</p>
<p>"那种感觉就像是被当众剥光了一样，"该女演员表示，"但当时我还是新人，不敢反抗，只能忍着。"</p>
<p>面对接连不断的指控，张某某方面暂未做出任何回应。但其工作室的社交媒体账号已关闭了评论功能。</p>
<p>中国电影家协会相关负责人在接受采访时表示，协会已经注意到相关情况，将按照行业规范展开调查。如果情况属实，将依据协会章程对当事人进行处理。</p>`,
    categorySlug: 'yule-neimu',
    categoryName: '娱乐内幕',
    imageUrl: 'https://readdy.ai/api/search-image?query=Film%20set%20with%20professional%20camera%20equipment%20and%20director%20chair%2C%20dramatic%20lighting%20on%20movie%20set%2C%20empty%20film%20studio%20with%20professional%20gear%2C%20behind%20the%20scenes%20cinema%20atmosphere%2C%20warm%20industrial%20lighting%2C%20moody%20professional%20environment&width=800&height=533&seq=article-hero-04&orientation=landscape',
    authorName: '圈内知情人',
    authorHandle: '@quannei_zhishi',
    publishedAt: '2026-07-05T14:20:00Z',
    viewCount: 72300,
    commentCount: 1988,
    tags: ['导演霸凌', '演员维权', '行业协会', '剧组内幕'],
    isHot: true,
    isFeatured: false,
  },
  {
    id: 'article-5',
    title: '选秀节目票数造假实锤！内部聊天记录曝光，节目组连夜开会应对危机',
    excerpt: '热门选秀节目《星光之路》被爆出粉丝投票存在严重造假行为，一份内部工作群聊天记录在网络疯传，揭露了节目组操纵票数的详细操作流程。',
    content: `<p>昨晚，一份疑似《星光之路》节目组内部工作群的聊天截图在社交媒体上疯传，内容令人震惊。</p>
<p>聊天记录显示，节目组工作人员在群内讨论如何"调整"选手票数，包括"给B组选手的目标票数再拉高20%""A选手今晚的数据不要太夸张，容易引起怀疑"等具体操作指令。</p>
<p>更令人愤怒的是，聊天记录还显示节目组对不同选手采取了不同的"调整策略"——签约选手会被"适当照顾"，而未签约的独立选手则会被"控制"在安全范围内。</p>
<p>这份聊天记录的曝光立即引发了广大粉丝的强烈不满。许多为偶像花费大量金钱投票的粉丝感到被欺骗，纷纷要求节目组给出解释并退款。</p>
<p>"我们辛辛苦苦投票，结果票数全是假的？这跟诈骗有什么区别！"一位粉丝在社交媒体上愤怒地写道。</p>
<p>对此，《星光之路》节目组连夜召开紧急会议，但目前尚未发布正式声明。有消息称，相关监管机构已经注意到此事，可能会介入调查。</p>`,
    categorySlug: '17-chigua',
    categoryName: '17吃瓜',
    imageUrl: 'https://readdy.ai/api/search-image?query=Talent%20show%20stage%20with%20dramatic%20spotlights%20and%20voting%20screen%20display%2C%20reality%20competition%20atmosphere%2C%20large%20LED%20screens%20showing%20vote%20counts%2C%20empty%20auditorium%20with%20stage%20lighting%2C%20entertainment%20production%20environment%2C%20dramatic%20purple%20and%20gold%20stage%20lights&width=800&height=533&seq=article-hero-05&orientation=landscape',
    authorName: '选秀观察家',
    authorHandle: '@xuanxiu_guancha',
    publishedAt: '2026-07-05T11:00:00Z',
    viewCount: 110800,
    commentCount: 4521,
    tags: ['选秀造假', '票数操纵', '粉丝维权', '星光之路'],
    isHot: true,
    isFeatured: false,
  },
  {
    id: 'article-6',
    title: '女星离婚内幕大揭秘！前夫出轨证据确凿，法院判决结果让网友大呼解气',
    excerpt: '知名女星离婚案终于尘埃落定，法院判决书中披露了其前夫婚内出轨的多项证据，最终女方获得大部分财产分割及子女抚养权。',
    content: `<p>持续两年之久的知名女星林某某离婚案终于迎来最终判决，法院判决书中的诸多细节让吃瓜群众大呼过瘾。</p>
<p>判决书显示，女方的律师团队收集了其前夫在婚姻存续期间出轨的完整证据链，包括酒店开房记录、转账记录、亲密照片以及多名证人的证词。这些证据在法庭上被一一呈现，令对方律师无从辩驳。</p>
<p>最终，法院判决双方离婚，女方获得约70%的夫妻共同财产，同时获得两个孩子的抚养权。男方还需每月支付高额的抚养费直至子女成年。</p>
<p>"这个结果太解气了！"一位关注此案已久的网友评论道，"出轨男就该净身出户！"</p>
<p>据了解，林某某在婚姻期间一直是家庭的主要经济来源，而前夫不仅没有尽到丈夫和父亲的责任，还多次使用家庭资金用于婚外情消费。</p>
<p>林某某本人通过律师发表简短声明，感谢法院的公正判决，并表示将专注于工作和抚养孩子，不会就此事再发表更多评论。</p>`,
    categorySlug: '91-chigua',
    categoryName: '91吃瓜',
    imageUrl: 'https://readdy.ai/api/search-image?query=Courthouse%20exterior%20with%20dramatic%20sky%2C%20legal%20documents%20on%20wooden%20desk%2C%20divorce%20proceedings%20concept%2C%20solemn%20atmosphere%2C%20justice%20theme%2C%20warm%20natural%20lighting%20through%20windows%2C%20professional%20legal%20environment%2C%20editorial%20photography&width=800&height=533&seq=article-hero-06&orientation=landscape',
    authorName: '法律吃瓜人',
    authorHandle: '@falu_chigua',
    publishedAt: '2026-07-04T15:30:00Z',
    viewCount: 145600,
    commentCount: 6234,
    tags: ['明星离婚', '出轨证据', '法院判决', '财产分割'],
    isHot: true,
    isFeatured: false,
  },
  {
    id: 'article-7',
    title: '网红情侣分手互撕！女方晒出男方冷暴力聊天记录，男方反指对方精神控制',
    excerpt: '拥有数百万粉丝的网红情侣"小鹿与大树"宣布分手后，双方在社交媒体上展开了一场激烈的互撕大战，让吃瓜群众目不暇接。',
    content: `<p>曾经被粉丝称为"最甜网红情侣"的"小鹿与大树"近日突然宣布分手，本以为会和平结束，没想到双方在社交媒体上展开了一场互相指责的战争。</p>
<p>女方"小鹿"率先发难，在社交平台上晒出了大量聊天记录截图，显示男方在恋爱期间存在严重的冷暴力行为——经常数天不回复消息、在重要节日玩失踪、以及在女方生病期间漠不关心。</p>
<p>"这一年多来我一直在忍耐，今天我决定不再沉默了，"小鹿写道，"冷暴力也是暴力，我希望我的经历能给其他女孩一个警醒。"</p>
<p>然而男方"大树"也不甘示弱，很快发长文反击，称女方在恋爱期间对他实施了"精神控制"，包括要求他删除所有异性朋友的联系方式、每天汇报行踪、以及长期的语言贬低。</p>
<p>双方粉丝各自站队，在评论区展开激烈争论，场面一度失控。一些中立的网友则表示："两个人都有问题，能分手挺好的，各自安好吧。"</p>
<p>目前双方仍在持续发布证据，这场互撕大战似乎远未到结束的时候。</p>`,
    categorySlug: 'wanghong-talou',
    categoryName: '网红塌房',
    imageUrl: 'https://readdy.ai/api/search-image?query=Broken%20heart%20concept%20with%20torn%20photograph%20on%20wooden%20table%2C%20emotional%20drama%2C%2C%20dramatic%20lighting%2C%20warm%20tone%2C%20soft%20focus%20background%2C%20melancholy%20mood%2C%20editorial%20style%2C%20artistic%20composition&width=800&height=533&seq=article-hero-07&orientation=landscape',
    authorName: '吃瓜一线',
    authorHandle: '@chigua_yixian',
    publishedAt: '2026-07-04T10:00:00Z',
    viewCount: 98700,
    commentCount: 3890,
    tags: ['网红情侣', '分手互撕', '冷暴力', '精神控制'],
    isHot: false,
    isFeatured: false,
  },
  {
    id: 'article-8',
    title: '知名歌手被曝抄袭！新歌旋律与海外小众歌曲高度雷同，制作人连夜回应',
    excerpt: '某知名华语歌手最新发布的主打歌被网友发现与一首三年前发布的海外小众歌曲旋律几乎一模一样，引发乐迷和业内人士的广泛讨论。',
    content: `<p>华语乐坛知名歌手周某上周发布的新专辑主打歌《星光》在上线后迅速登上各大音乐平台榜首，然而随之而来的"抄袭"指控却让这首热门歌曲陷入了争议漩涡。</p>
<p>有网友发现，《星光》的副歌部分旋律与一位海外小众音乐人三年前发布的歌曲《Starlight》高度相似，不仅旋律走向几乎一致，连和弦进行和编曲风格都如出一辙。</p>
<p>"这已经不是借鉴的程度了，简直是复制粘贴，"一位音乐制作人在社交平台上评论道，"我同时播放了两首歌，毫不夸张地说，重合度在90%以上。"</p>
<p>面对越来越大的争议，周某的制作团队连夜发布声明，承认在创作过程中"确实参考了"该海外歌曲，但强调这属于"合理的音乐借鉴"而非抄袭。</p>
<p>然而这一说法并未平息舆论。多位音乐版权律师指出，根据中国著作权法，如果实质性相似程度如此之高，已经构成了侵权。</p>
<p>截至目前，被抄袭的海外音乐人尚未对此事做出回应。但有消息称，其版权代理公司正在评估采取法律行动的可能性。</p>`,
    categorySlug: '17-chigua',
    categoryName: '17吃瓜',
    imageUrl: 'https://readdy.ai/api/search-image?query=Music%20recording%20studio%20with%20professional%20equipment%2C%20microphone%20and%20headphones%20on%20stand%2C%20sheet%20music%20on%20desk%2C%20warm%20moody%20studio%20lighting%2C%20creative%20atmosphere%2C%20music%20production%20environment%2C%20editorial%20photography%20style%2C%20soft%20shadows&width=800&height=533&seq=article-hero-08&orientation=landscape',
    authorName: '乐评人老王',
    authorHandle: '@yueping_laowang',
    publishedAt: '2026-07-03T13:15:00Z',
    viewCount: 67800,
    commentCount: 1567,
    tags: ['音乐抄袭', '版权争议', '华语乐坛', '新歌发布'],
    isHot: false,
    isFeatured: false,
  },
  {
    id: 'article-9',
    title: '某知名品牌代言人突然被换！品牌方内部人士透露背后真正原因令人震惊',
    excerpt: '某国际知名品牌突然宣布更换其中国区代言人，官方给出的理由是"合同到期"，但据内部人士透露，真正原因与代言人近期的负面新闻有关。',
    content: `<p>昨日，某国际知名奢侈品牌突然在官方社交媒体上宣布，将更换其在中国区的品牌代言人，由原来的演员陈某某换为新生代艺人王某。</p>
<p>品牌官方给出的解释是"前代言人合约到期，经双方友好协商不再续约"，但这一说法显然无法让关注此事的网友信服。</p>
<p>就在品牌官宣的前三天，陈某某刚被爆出在私人聚会上发表不当言论的视频。虽然陈某某方面很快发布了道歉声明，但该事件已经对其公众形象造成了严重影响。</p>
<p>一位不愿透露姓名的品牌内部人士向记者证实："确实是受到了那件事的影响。品牌方高层担心代言人的负面形象会损害品牌声誉，所以决定提前终止合作。所谓的'合约到期'只是对外的一种体面说法。"</p>
<p>这一爆料让不少网友感慨："明星真的不能犯错，一失足成千古恨啊。"也有人认为品牌方做法过于绝情："合作这么多年，一出事就撇清关系，太现实了。"</p>
<p>陈某某方面对此暂未做出回应。而新任代言人王某则在签约后发布了与品牌合作的宣传内容，引发新一波讨论。</p>`,
    categorySlug: 'yule-neimu',
    categoryName: '娱乐内幕',
    imageUrl: 'https://readdy.ai/api/search-image?query=Luxury%20brand%20billboard%20in%20shopping%20district%2C%20fashion%20advertisement%20display%2C%20urban%20commercial%20area%2C%20modern%20city%20street%2C%20high-end%20retail%20environment%2C%20warm%20afternoon%20sunlight%2C%20editorial%20commercial%20photography%2C%20clean%20composition&width=800&height=533&seq=article-hero-09&orientation=landscape',
    authorName: '品牌观察员',
    authorHandle: '@pinpai_guancha',
    publishedAt: '2026-07-03T09:45:00Z',
    viewCount: 54300,
    commentCount: 1234,
    tags: ['品牌代言', '代言人更换', '明星翻车', '奢侈品牌'],
    isHot: false,
    isFeatured: false,
  },
  {
    id: 'article-10',
    title: '某老戏骨被曝税务问题！工作室紧急回应：正在积极配合税务机关检查',
    excerpt: '继多位明星艺人陷入税务风波后，又一位德高望重的老戏骨被曝出存在税务问题。其工作室火速回应称正在积极配合税务机关进行检查。',
    content: `<p>据税务系统内部消息人士透露，曾在多部经典影视作品中塑造深入人心的角色的老戏骨刘某某，近日被税务机关约谈，原因是其个人及关联公司存在税务申报问题。</p>
<p>知情人士称，税务机关在对刘某某近三年的税务申报情况进行核查时，发现其个人劳务报酬所得与关联公司的账目存在多处不一致的情况，涉及的金额可能达到数千万元。</p>
<p>"主要是通过关联公司将个人收入转化为企业收入，以此规避个人所得税的高税率，"该知情人士解释，"这在演艺圈其实比较常见，但一旦被查实，后果会很严重。"</p>
<p>消息曝光后，刘某某工作室迅速发表声明，承认正在配合税务机关进行检查，但强调"所有问题都在正常核查范围内，不存在违法行为"。声明还表示将"尊重并配合税务机关的一切决定"。</p>
<p>然而，网友对这一解释并不买账。有人翻出了刘某某此前在公开场合批评年轻艺人"不守规矩"的言论，讽刺这是"回旋镖"。</p>
<p>近年来，税务问题已经成为演艺圈的高危雷区，多位明星因此葬送职业生涯。刘某某能否挺过这一关，目前还是未知数。</p>`,
    categorySlug: '91-chigua',
    categoryName: '91吃瓜',
    imageUrl: 'https://readdy.ai/api/search-image?query=Tax%20documents%20and%20calculator%20on%20office%20desk%2C%20financial%20audit%20concept%2C%20professional%20office%20environment%2C%20business%20paperwork%2C%20warm%20desk%20lamp%20lighting%2C%20serious%20atmosphere%2C%20editorial%20photography%20style%2C%20clean%20professional%20composition&width=800&height=533&seq=article-hero-10&orientation=landscape',
    authorName: '财经吃瓜哥',
    authorHandle: '@caijing_chigua',
    publishedAt: '2026-07-02T16:00:00Z',
    viewCount: 78900,
    commentCount: 2890,
    tags: ['税务问题', '老戏骨', '税务机关', '演艺圈'],
    isHot: false,
    isFeatured: false,
  },
  {
    id: 'article-11',
    title: '热门电视剧女主角突然辞演！剧组损失惨重，知情人士爆料与片酬有关',
    excerpt: '备受期待的年度大剧《长安风云》开机仅一周，女主角便突然宣布辞演，导致剧组陷入停摆。据传辞演原因与片酬分配不公有关。',
    content: `<p>由著名导演郑某某执导的古装大剧《长安风云》上个月刚刚举行了隆重的开机仪式，然而就在开机仅一周之后，女主角扮演者赵某某便通过工作室宣布退出该剧。</p>
<p>这份突如其来的声明让整个剧组陷入了混乱。据业内人士估算，此次换角将导致剧组损失超过2000万元，包括已拍摄场景的废弃、演员档期的重新协调以及制作周期的延长等。</p>
<p>关于赵某某辞演的原因，官方声明只提到"因个人档期原因无法继续出演"，但这一说法显然无法令人信服——一个演员在签约开拍后才"发现档期冲突"，这几乎是不可能的。</p>
<p>多位知情人士透露，真正的原因与片酬有关。据悉，该剧男主角的片酬是女主角的2.5倍，而这个差距在签约前并没有被明确告知赵某某。</p>
<p>"她在进组后才从其他渠道得知这个差距，觉得自己被欺骗了，"一位接近赵某某团队的人士透露，"而且这部剧本来就是大女主戏，结果女主片酬远低于男主，她无法接受。"</p>
<p>目前，剧组正在紧急寻找替代人选。但能够接替这一角色的合适演员档期大多已满，该剧的前景变得扑朔迷离。</p>`,
    categorySlug: 'zongyi-bagua',
    categoryName: '综艺八卦',
    imageUrl: 'https://readdy.ai/api/search-image?query=Historical%20Chinese%20drama%20film%20set%20with%20traditional%20costumes%20and%20props%2C%20empty%20movie%20set%20with%20ancient%20Chinese%20architecture%2C%20cinematic%20lighting%2C%20behind%20the%20scenes%20film%20production%2C%20warm%20atmospheric%20lighting%2C%20professional%20film%20equipment&width=800&height=533&seq=article-hero-11&orientation=landscape',
    authorName: '剧组内线',
    authorHandle: '@juzu_neixian',
    publishedAt: '2026-07-02T11:30:00Z',
    viewCount: 61200,
    commentCount: 1876,
    tags: ['电视剧', '女主角辞演', '片酬纠纷', '剧组停摆'],
    isHot: false,
    isFeatured: false,
  },
  {
    id: 'article-12',
    title: '年度吃瓜大赛：2026上半年娱乐圈十大名场面盘点，你错过了几个？',
    excerpt: '2026年上半年娱乐圈好戏连台，从顶流塌房到综艺翻车，从离婚互撕到抄袭实锤，我们为你整理了一份上半年的吃瓜清单。',
    content: `<p>2026年上半年即将过去，这半年来娱乐圈可谓是精彩纷呈、好戏连台。作为一名合格的吃瓜群众，以下这十大名场面，你关注了几个？</p>
<p><strong>第一名：顶流男星深夜密会神秘女子</strong>——当红男星被拍到与神秘女子酒店共度8小时，经纪人回应"剧本研讨"成为年度最苍白解释。</p>
<p><strong>第二名：选秀节目票数造假实锤</strong>——内部聊天记录曝光，节目组操纵票数的操作流程被完整揭露，粉丝要求退款的声音此起彼伏。</p>
<p><strong>第三名：直播带货翻车事件</strong>——千万粉丝主播因虚假宣传被品牌方"割席"，直播带货行业信任危机加剧。</p>
<p><strong>第四名：综艺录制现场嘉宾互殴</strong>——两位常驻嘉宾因一句话大打出手，节目录制被迫中断三小时。</p>
<p><strong>第五名：老戏骨税务问题曝光</strong>——继多位明星税务风波后，德高望重的老演员也陷入其中。</p>
<p>……</p>
<p>更多精彩内容，敬请关注黑料吃瓜网的后续报道。这个夏天，瓜田里的瓜还有很多，我们慢慢吃。</p>`,
    categorySlug: 'meiri-dasai',
    categoryName: '每日大赛',
    imageUrl: 'https://readdy.ai/api/search-image?query=Entertainment%20news%20collage%20concept%2C%20colorful%20magazine%20covers%20arranged%20on%20wall%2C%20pop%20culture%20headlines%2C%20vibrant%20creative%20atmosphere%2C%20editorial%20design%20aesthetic%2C%20warm%20studio%20lighting%2C%20artistic%20composition%2C%20bold%20typography%20on%20display&width=800&height=533&seq=article-hero-12&orientation=landscape',
    authorName: '年度盘点君',
    authorHandle: '@niandu_pandian',
    publishedAt: '2026-07-01T08:00:00Z',
    viewCount: 203400,
    commentCount: 8921,
    tags: ['年度盘点', '娱乐圈', '2026上半年', '名场面'],
    isHot: true,
    isFeatured: true,
  },
];

export const testimonials = [
  {
    name: '资深吃瓜群众',
    handle: '@chigua_daren',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20portrait%20avatar%20abstract%20geometric%20style%2C%20coral%20and%20warm%20tones%2C%20clean%20background%2C%20modern%20design&width=80&height=80&seq=avatar-01&orientation=squarish',
    quote: '这个网站更新太快了！我每天上班第一件事就是打开黑料吃瓜网，看看有没有什么新瓜。比刷微博效率高多了，信息很全。',
  },
  {
    name: '娱乐圈观察者',
    handle: '@yule_observer',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20portrait%20avatar%20abstract%20style%2C%20warm%20amber%20and%20neutral%20tones%2C%20clean%20background%2C%20modern%20flat%20design&width=80&height=80&seq=avatar-02&orientation=squarish',
    quote: '作为一个在娱乐圈混了十年的老人，我不得不说黑料吃瓜网的信息准确度相当高。虽然有删减，但核心事实基本都对得上。',
  },
  {
    name: '八卦小能手',
    handle: '@bagua_master',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20portrait%20avatar%20abstract%20style%2C%20soft%20pink%20and%20cream%20tones%2C%20clean%20background%2C%20contemporary%20art%20design&width=80&height=80&seq=avatar-03&orientation=squarish',
    quote: '全网吃瓜就服这家！别的地方还在传谣言的时候，这里已经有实锤了。分类也很清晰，想吃什么瓜直接去对应板块就行。',
  },
  {
    name: '深夜吃瓜人',
    handle: '@night_reader',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20portrait%20avatar%20abstract%20style%2C%20sage%20green%20and%20neutral%20tones%2C%20clean%20background%2C%20modern%20illustration&width=80&height=80&seq=avatar-04&orientation=squarish',
    quote: '不打烊这个设计太贴心了，我经常半夜睡不着就来逛逛。深夜吃瓜，别有一番风味。希望网站越做越好！',
  },
  {
    name: '追星前线站姐',
    handle: '@star_chaser',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20portrait%20avatar%20abstract%20style%2C%20terracotta%20and%20cream%20tones%2C%20clean%20background%2C%20modern%20graphic%20design&width=80&height=80&seq=avatar-05&orientation=squarish',
    quote: '作为站姐，很多消息我都是从黑料吃瓜网先看到的。消息源真的很厉害，很多内幕比我这个在一线的人都先知道。',
  },
  {
    name: '路人吃瓜者',
    handle: '@passerby_eater',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20portrait%20avatar%20abstract%20style%2C%20warm%20beige%20and%20taupe%20tones%2C%20clean%20background%2C%20flat%20design%20illustration&width=80&height=80&seq=avatar-06&orientation=squarish',
    quote: '我一个不追星的人都被这个网站吸引了。每天中午吃饭的时候看看，比看电视剧还精彩。推荐给了身边所有同事。',
  },
];

export const stats = [
  { value: '10万+', label: '每日活跃用户' },
  { value: '5000+', label: '累计爆料文章' },
  { value: '98%', label: '内容准确率' },
  { value: '6个', label: '内容分类板块' },
];

export const faqItems = [
  {
    question: '黑料吃瓜网的内容来源是什么？',
    answer: '我们的内容来源于多渠道的信息收集，包括社交媒体爆料、行业内部人士提供、网友投稿以及公开新闻报道等。所有内容在发布前都经过多轮核实，确保信息的真实性和准确性。',
  },
  {
    question: '黑料吃瓜网是否涉及侵犯隐私？',
    answer: '我们严格遵守相关法律法规，所有报道内容均基于公开信息和合法渠道获取。我们不会发布涉及个人隐私的非公开信息，也拒绝任何通过非法手段获取的爆料内容。',
  },
  {
    question: '如何在黑料吃瓜网上投稿爆料？',
    answer: '您可以通过我们的官方邮箱或社交媒体账号提交爆料信息。我们会对所有投稿进行严格的审核和核实，确保内容真实可靠后再进行发布。同时我们会对爆料人的信息严格保密。',
  },
  {
    question: '黑料吃瓜网多久更新一次内容？',
    answer: '我们保持24小时不间断的内容更新。重大爆料事件发生后，我们的团队会在第一时间进行跟踪报道，确保用户能够最快获取到最新、最全面的信息。',
  },
  {
    question: '黑料吃瓜网有手机APP吗？',
    answer: '目前我们主要通过官方网站提供内容服务，网站已经做了完善的移动端适配，您可以直接在手机浏览器中访问。APP正在开发中，敬请期待。',
  },
];

export function getArticleById(id: string): Article | undefined {
  return articles.find((a) => a.id === id);
}

export function getArticlesByCategory(slug: string): Article[] {
  return articles.filter((a) => a.categorySlug === slug);
}

export function getHotArticles(): Article[] {
  return articles.filter((a) => a.isHot);
}

export function getFeaturedArticles(): Article[] {
  return articles.filter((a) => a.isFeatured);
}

export function getLatestArticles(count: number = 6): Article[] {
  return [...articles].sort(
    (a, b) => new Date(b.publishedAt).getTime() - new Date(a.publishedAt).getTime()
  ).slice(0, count);
}

export function getRelatedArticles(currentId: string, categorySlug: string, count: number = 3): Article[] {
  return articles
    .filter((a) => a.id !== currentId && a.categorySlug === categorySlug)
    .slice(0, count);
}